import { render, staticRenderFns } from "./customerNote.vue?vue&type=template&id=4954d0c8&scoped=true&"
import script from "./customerNote.vue?vue&type=script&lang=js&"
export * from "./customerNote.vue?vue&type=script&lang=js&"
import style0 from "./customerNote.vue?vue&type=style&index=0&id=4954d0c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954d0c8",
  null
  
)

export default component.exports